import React from 'react';
import { ArServiceContextProvider } from './AccountsReceivableServiceContext';
import ArPastDuePage from './ArPastDuePage';
const ArPastDueComponent = () => {
  return (
    <ArServiceContextProvider>
      <ArPastDuePage />
    </ArServiceContextProvider>
  );
};
export default ArPastDueComponent;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/ArPastDueComponent.tsx